/**
 * trackPlyxInstall — fire-and-forget install-funnel telemetry.
 *
 * Wraps the existing POST /api/analytics/event endpoint so the four
 * install touch-points (pill shown, FAB tapped, install started, install
 * completed/dismissed) hit a single namespace prefix (`ux_plyx_install_*`)
 * that the admin install-funnel aggregator buckets by name.
 *
 * Never blocks on failure — every call is wrapped in try/catch so a
 * dead network never breaks the UX.
 */
import { plyxApi } from "@/lib/plyxApi";

const SESSION_KEY = "plyx-analytics-session";

const getOrCreateSession = () => {
  let sid = sessionStorage.getItem(SESSION_KEY);
  if (!sid) {
    sid = `pas_${Math.random().toString(36).slice(2, 10)}${Date.now().toString(36)}`;
    sessionStorage.setItem(SESSION_KEY, sid);
  }
  return sid;
};

export const trackPlyxInstall = (event, props = {}) => {
  // Tiny safety net — events outside the install namespace shouldn't
  // be routed through this helper. Caller passes the short suffix
  // ("pill_shown", "fab_tapped", "started", "completed", "dismissed").
  const name = `ux_plyx_install_${event}`;
  const url = typeof window !== "undefined" ? window.location.pathname : null;
  // Don't await — the install UX must not stall on a slow ping.
  plyxApi
    .post("/analytics/event", {
      event: name,
      session_id: getOrCreateSession(),
      url,
      props: {
        ...props,
        // Best-effort surface attribution: standalone display mode,
        // UA family hints, and viewport so the funnel can break out
        // by Android vs iOS vs desktop later without a schema change.
        standalone:
          typeof window !== "undefined" &&
          (window.matchMedia?.("(display-mode: standalone)").matches ||
            window.navigator?.standalone === true),
      },
    })
    .catch(() => {});
};

export default trackPlyxInstall;
